import DatePick from "components/DatePicker";
import useErrorHandler from "../FormErrorHandler";
import {
  TextInput,
  FormInputRow,
  FormSection,
  FormHeader,
  RadioInput,
} from "../../FormInput/FormInput";

const GettingStarted = ({ formData, handleInputChange, validateForm }) => {
  const { error, addError, clearError, hasError } = useErrorHandler();

  const validate = (formData) => {
    clearError();

    if (involvedVehicleIndex == "other" || !involvedVehicleIndex) {
      if (!formData.vehicleInfo.year) {
        addError({ year: "Vehicle Year is required" });
      }

      if (!formData.vehicleInfo.make) {
        addError({ make: "Vehicle Make is required" });
      }

      if (!formData.vehicleInfo.model) {
        addError({ model: "Vehicle Model is required" });
      }
    }

    if (!formData.vehicleInfo.registeredTo) {
      addError({ registeredTo: "This field is required" });
    }

    if (!formData.vehicleInfo.priorDamage) {
      addError({ priorDamage: "This field is required" });
    }

    return !hasError();
  };

  const handlePriorDamageSelection = (field, value, parent) => {
    handleInputChange(field, value, parent)
    if(value == "No")
      handleInputChange("priorDamageDescription", null, parent)
  }

  validateForm.current = validate;

  const involvedVehicleIndex = formData.involvedVehicleIndex;
  const noVehicleSelected =
    !involvedVehicleIndex || involvedVehicleIndex == "other";
  const involvedVehicleInfo =
    !noVehicleSelected && formData.vehicles[involvedVehicleIndex];

  const involvedVehicleInfoDisplay = (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "8px",
      }}
    >
      <div>Vehicle:</div>
      <div
        style={{
          textAlign: "right",
          wordBreak: "break-word",
        }}
      >
        {involvedVehicleInfo.year} {involvedVehicleInfo.make}{" "}
        {involvedVehicleInfo.model} - ({involvedVehicleInfo.VIN})
      </div>
    </div>
  );

  return (
    <div>
      <FormHeader>VEHICLE INFORMATION</FormHeader>
      <FormSection>
        {!noVehicleSelected && (
          <FormInputRow
            textColor={"blue"}
            header={involvedVehicleInfoDisplay}
          />
        )}

        {noVehicleSelected && (
          <>
            <FormInputRow header="Vehicle VIN" sameLine={true}>
              <TextInput
                fieldName="vin"
                value={formData.vehicleInfo.vin}
                handleInputChange={handleInputChange}
                parentField="vehicleInfo"
              />
            </FormInputRow>
            <FormInputRow header="Vehicle Year*" sameLine={true}>
              <TextInput
                fieldName="year"
                value={formData.vehicleInfo.year}
                handleInputChange={handleInputChange}
                error={error}
                parentField="vehicleInfo"
              />
            </FormInputRow>
            <FormInputRow header="Vehicle Make*" sameLine={true}>
              <TextInput
                fieldName="make"
                value={formData.vehicleInfo.make}
                handleInputChange={handleInputChange}
                error={error}
                parentField="vehicleInfo"
              />
            </FormInputRow>
            <FormInputRow header="Vehicle Model*" sameLine={true}>
              <TextInput
                fieldName="model"
                value={formData.vehicleInfo.model}
                handleInputChange={handleInputChange}
                error={error}
                parentField="vehicleInfo"
              />
            </FormInputRow>
          </>
        )}

        <FormInputRow header="Vehicle Color" sameLine={true}>
          <TextInput
            fieldName="color"
            value={formData.vehicleInfo.color}
            handleInputChange={handleInputChange}
            parentField="vehicleInfo"
          />
        </FormInputRow>

        <FormInputRow header="Vehicle Plate #" sameLine={true}>
          <TextInput
            fieldName="plateNumber"
            value={formData.vehicleInfo.plateNumber}
            handleInputChange={handleInputChange}
            parentField="vehicleInfo"
          />
        </FormInputRow>

        <FormInputRow header="Vehicle Mileage" sameLine={true}>
          <TextInput
            fieldName="mileage"
            value={formData.vehicleInfo.mileage}
            handleInputChange={handleInputChange}
            parentField="vehicleInfo"
          />
        </FormInputRow>

        <FormInputRow header="Vehicle Owner" sameLine={true}>
          <TextInput
            fieldName="owner"
            value={formData.vehicleInfo.owner}
            handleInputChange={handleInputChange}
            parentField="vehicleInfo"
          />
        </FormInputRow>

        <FormInputRow
          header="Who is this vehicle registered to?*"
          sameLine={true}
        >
          <TextInput
            fieldName="registeredTo"
            value={formData.vehicleInfo.registeredTo}
            handleInputChange={handleInputChange}
            error={error}
            parentField="vehicleInfo"
          />
        </FormInputRow>

        <FormInputRow
          header="Was there any prior damage to this vehicle unrelated to this loss?*"
          sameLine={true}
        >
          <RadioInput
            fieldName="priorDamage"
            value={formData.vehicleInfo.priorDamage}
            handleInputChange={handlePriorDamageSelection}
            error={error}
            parentField="vehicleInfo"
            sameLine={true}
            options={[
              { label: "Yes", value: "Yes" },
              { label: "No", value: "No" },
            ]}
            sameLineAsHeader={true}
          />
        </FormInputRow>

        {formData.vehicleInfo.priorDamage == "Yes" && (
          <FormInputRow header="Describe Prior Damage" sameLine={true}>
            <TextInput
              fieldName="priorDamageDescription"
              value={formData.vehicleInfo.priorDamageDescription}
              handleInputChange={handleInputChange}
              error={error}
              parentField="vehicleInfo"
            />
          </FormInputRow>
        )}
      </FormSection>
    </div>
  );
};

export default GettingStarted;
